const SIGNING_ERRORS = {
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  USER_LOGIN_CANCEL: 'USER_LOGIN_CANCEL',
  STATUS_ERROR: 'STATUS_ERROR',
  START_ERROR: 'START_ERROR',
};

export default SIGNING_ERRORS;
